import { useContext } from 'react';

import { GroupContext } from '../Contexts/index';

const useGroups = () => {
  return useContext(GroupContext);
};

export default useGroups;
